import * as React from 'react'

function TravelServiceIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={198} height={90.659} viewBox="0 0 198 90.659" {...props}>
      <g data-name="Social distance at the beach-bro" stroke="#263238" strokeLinecap="round" strokeLinejoin="round">
        <g transform="translate(0 .572) translate(33.512) rotate(9 20.205 256.735)">
          <path
            data-name="Path 13922"
            d="M0 15.878a23.538 23.538 0 014.3 5c1.236 2.307.983 2.151 3.449 3s9.347 2.662 12.231 3.526 11.09 4.009 11.508 3.758 1.456-.889 1.456-.889 1.717 1.637 2.833 1.7 12 .579 18.8 1.269 7.977.061 8.971-.158a4.521 4.521 0 001.889-1.149 5.813 5.813 0 002.876 1.009c1.673.1 18.561-3.466 20.392-3.656s2.465-1.383 4.28-1.275 1.183-1.045 2.406-2.645a13.852 13.852 0 012.974-2.752l.1-1.529s-10.573-5.518-16.977-8.272-17.107-3.959-29.882-5.561-29.112 2.155-34.082 3.252-13.566 4.223-13.566 4.223z"
            fill="#e5e5e5"
            strokeWidth={1}
          />
          <path
            data-name="Path 13923"
            d="M6.531 23.362a16.439 16.439 0 01.772-3.173c.497-1.232 9.149-5.188 9.149-5.188"
            fill="none"
            strokeWidth={1}
          />
          <path data-name="Path 13924" d="M32.889 30.297s6.946-17.093 8.714-18.528" fill="none" strokeWidth={1} />
          <path
            data-name="Line 305"
            transform="translate(59.89 13.418)"
            fill="none"
            strokeWidth={1}
            d="M5.526 18.554L0 0"
          />
          <path
            data-name="Path 13925"
            d="M92.188 27.969a64.763 64.763 0 00-7.772-7.746 66.855 66.855 0 00-6.543-5.016"
            fill="none"
            strokeWidth={1}
          />
          <path
            data-name="Line 306"
            transform="translate(45.331 10.701)"
            fill="none"
            strokeWidth={3}
            d="M3.784 0L0 70.902"
          />
          <path
            data-name="Path 13926"
            d="M36.154 1.976A40.942 40.942 0 0024.43 3.638C17.168 5.569 6.121 12 4.516 13.033S0 15.827 0 15.827s1.578 1.628 2.683 1.7 20.307-2.4 21.6-2.883 2.843-2.894 4.607-2.1a16.837 16.837 0 002.45 1.142c.418.041 14.162-.4 25.018.529s12.659 1.177 13.665.821 1.353-1.453 2.962-.386 2.545 1.825 3.938 1.9 5.337-.237 9.421 1.544 9.122 4.031 10.518 4.113a1.466 1.466 0 001.613-1.148A84.7 84.7 0 0085.807 11.1c-6.735-4.168-18.022-7.229-20.5-7.775s-3.113-1.721-5.752-2.157S45.771.046 42.414 0a12.09 12.09 0 00-6.26 1.976z"
            fill="#fff"
            strokeWidth={1}
          />
          <path data-name="Path 13927" d="M36.073 1.895s-5.539 5.684-8.069 10.294" fill="none" strokeWidth={1} />
          <path data-name="Path 13928" d="M64.185 3.078s5.388 5.508 7.842 10.978" fill="none" strokeWidth={1} />
        </g>
        <g transform="translate(0 .572) translate(33.512) translate(0 37.81)" strokeWidth={1}>
          <path data-name="Path 13929" d="M31.01 0L0 51.152h1.513L32.283 0z" fill="#fff" />
          <path data-name="Path 13930" d="M32.284 0v1.688L2.776 51.152H1.514z" fill="#263238" />
          <path data-name="Path 13931" d="M64.27 1.066H32.195l-17.3 30.932h31.82z" fill="#fff" />
          <path data-name="Path 13935" d="M2.598 20.223l23.374 30.929h1.946L4.605 20.19z" fill="#fff" />
          <path data-name="Path 13936" d="M4.605 20.193l-.154-1.057 23.47 30.825v1.194z" fill="#263238" />
          <path data-name="Rectangle 2304" transform="translate(2.579 19.133)" fill="#fff" d="M0 0H1.872V0.991H0z" />
          <path
            data-name="Path 13951"
            d="M32.671 20.079H4.451l12.31 16.88a39.749 39.749 0 0017.425 1.36c9.562-1.438 10.322-3.437 10.322-3.437z"
            fill="#fff"
          />
          <path
            data-name="Rectangle 2305"
            transform="translate(17.928 38.508)"
            fill="#263238"
            d="M0 0H36.113V1.494H0z"
          />
          <path data-name="Rectangle 2306" transform="translate(17.928 38.508)" fill="#fff" d="M0 0H34.156V1.494H0z" />
          <path data-name="Path 13952" d="M32.052 20.223l23.37 30.929h1.95L34.059 20.19z" fill="#fff" />
          <path data-name="Path 13953" d="M34.059 20.193l-.154-1.057 23.467 30.825v1.194z" fill="#263238" />
          <path data-name="Rectangle 2307" transform="translate(32.033 19.133)" fill="#fff" d="M0 0H1.872V0.991H0z" />
          <path
            data-name="Rectangle 2308"
            transform="rotate(180 27.198 23.85)"
            fill="#263238"
            d="M0 0H0.861V26.709H0z"
          />
          <path data-name="Rectangle 2309" transform="translate(52.114 22.017)" fill="#fff" d="M0 0H1.424V25.685H0z" />
          <path data-name="Path 13954" d="M64.347 0L33.334 51.152h1.513L65.617 0z" fill="#fff" />
          <path data-name="Path 13955" d="M65.617 0v1.688L36.109 51.152h-1.262z" fill="#263238" />
        </g>
      </g>
      <path
        data-name="Line 254"
        fill="none"
        stroke="#000"
        strokeLinejoin="round"
        strokeWidth={1}
        transform="translate(0 .572) translate(0 89.338)"
        d="M0 0L198 0"
      />
    </svg>
  )
}

export default TravelServiceIcon
